import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

import { logError } from './utils/logging'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      logError(error)
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      logError(error)
    },
  }),
})
